import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuditMemberService
{
  constructor(private http: HttpClient) { }

  /**
   * Get audit member details
   *
   * @param memberId Member Id
   * @param revisionId Revision Id
   */
  public getAuditMemberDetails(memberId: number, revisionId: number): Observable<any>
  {
    return this.http.get<any>(`/audit/member/details/${memberId}/${revisionId}`);
  }

  public getAuditMemberExtensionDetails(memberId: number, revisionId: number, revisionType: number): Observable<any>
  {
    return this.http.get<any>(`/audit/member/extension/details/${memberId}/${revisionId}/${revisionType}`);
  }  
}
